import { forwardRef, type InputHTMLAttributes } from 'react';
import { DATE_INPUT_MAX, DATE_INPUT_MIN } from './DateInput';

/**
 * Native datetime-local med max som begränsar året till 4 siffror.
 * Samma Chromium-problem som type="date": utan max kan årsfältet ta
 * 6 siffror så manuell inmatning (t.ex. 20260703) fastnar på 5:e tecknet.
 *
 * Tomt värde under inmatning ska få propageras; säkra ISO-konvertering i konsument.
 */
export const DATETIME_LOCAL_INPUT_MAX = `${DATE_INPUT_MAX}T23:59`;
export const DATETIME_LOCAL_INPUT_MIN = `${DATE_INPUT_MIN}T00:00`;

export type DateTimeLocalInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const DateTimeLocalInput = forwardRef<HTMLInputElement, DateTimeLocalInputProps>(
  function DateTimeLocalInput(
    { min = DATETIME_LOCAL_INPUT_MIN, max = DATETIME_LOCAL_INPUT_MAX, ...rest },
    ref,
  ) {
    return <input ref={ref} type="datetime-local" min={min} max={max} {...rest} />;
  },
);

export default DateTimeLocalInput;
